export default "__VITE_ASSET__Cd2biSeE__"